import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Access, AuthData, Company, UserData } from '../../../interfaces/auth.interface';


export type SeeInformationAs = "grid" | "card";
export interface Auth {
    // userToken: string | null;
    userHasProfilePicture: boolean | null,
    usersWithoutProfilePicture: string[],
    userData: UserData | null;
    sessionData: AuthData | null;
    companyselected: Company | null;
    isLogged: boolean | null;
    isLoading: boolean;
    autherror: string;
    connectionId: string | null;
    userMenu: Access[];
    seeInformationAs: SeeInformationAs;
}


    // Id: number;
    // SecurityRoleId: number;
    // SecurityAccessId: number;
    // IsStartPage: boolean;
    // Name: string;
    // ItemPath: string;
    // Icon: string;
    // Visible: boolean;
    // ParentId?: number;
    // Order: number;
    // Level: number;
    // children?: Access[],
    // urlPath: string


const userMenu = [
    {
        Id: 1,
        Name: 'Contabilidad',
        Level: 0,
        Order: 1,
        urlPath: '/contabilidad',
        children: [{
                Id: 11,
                Name: 'Libro Diario',
                ParentId: 1,
                Level: 1,
                Order: 1,
                urlPath: '/contabilidad/libro-diario',
            },{
                Id: 12,
                Name: 'Sincronizar Libro Diario',
                ParentId: 1,
                Level: 1,
                Order: 2,
                urlPath: '/contabilidad/sincronizar-libro-diario',
            },
        ]
    },
    
];

const initialState: Auth = {
    // userToken: null,
    usersWithoutProfilePicture: [],
    userHasProfilePicture: null,
    userData: null,
    sessionData: null,
    companyselected: null,
    isLogged: null,
    isLoading: false,
    autherror: "",
    connectionId: null,
    userMenu: userMenu,
    seeInformationAs: "card",
}

const normalizeTitle = (title: string) => {
    const normalizedTitle = title.toLowerCase()
      .normalize('NFKD') // Normalizar caracteres especiales
      .replace(/[\u0301-\u036F]/g, '') // Eliminar acentos
      .replace(/[aeiouy]/g, function (char) {
        return char.replace(/á|é|í|ó|ú|ä|ë|ï|ö|ü/g, char[0]);
      }) // Reemplazar vocales con acento por su equivalente sin acento
      .replace(/[^\w-]+/g, '-') // Reemplazar otros caracteres por guiones
      .replace(/--/g, '-'); // Eliminar dobles guiones
    return normalizedTitle;
};

export const getMenuData = (menuOptions: Access[], ParentId: number | null = null, level=0, parentPath = ""): Access[] => {
    const itemsLevel = menuOptions?.filter(m => m.Level === level && m.ParentId === ParentId)
                        .sort((a, b) => a.Order - b.Order);
    const itemsNextLevel = menuOptions?.filter(m => m.Level > level);
    const finalItems: Access[] = []
    for (let index = 0; index < itemsLevel?.length; index++) {
        const item = itemsLevel[index]
        const currentPath = `${parentPath}/${normalizeTitle(item.Name)}`;
        const children = getMenuData(
            itemsNextLevel, 
            item.SecurityAccessId, 
            level + 1,
            currentPath 
        );
        finalItems.push({
            ...item,
            children: children,
            urlPath: currentPath,
        })
        
    }
    return finalItems;
}

const handlerSetCompanySelected = (state: any, action: PayloadAction<Company>) => {
    const companyData = action.payload;
    state.companyselected = companyData;
    // const userMenu = getMenuData(companyData.Roles?.Access);
    // // TODO: this is only for test
    // if (['ncortez@s10peru.com', 'lsarayasi@s10peru.com'].includes(state.sessionData?.UserName)) {
    //     // userMenu.map((parent: Access) => ({
    //     //     ...parent,
    //     //     children: parent.Name === 'Mi Portal' 
    //     //             ? parent?.children?.push({
    //     //                 ...parent.children[0],
    //     //                 Id: 0,
    //     //                 Name: 'marcaciones',
    //     //                 ItemPath: 'marcaciones',
    //     //                 urlPath: '/mi-portal/mis-marcaciones',
    //     //             })
    //     //             : parent?.children,
    //     // }))
    // }
    // state.userMenu = userMenu;
    localStorage.setItem('companySelected', JSON.stringify(action.payload));
    localStorage.setItem('userMenu', JSON.stringify(userMenu));
    // window.location.reload();
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout: (state) => {
            const savedUSername = localStorage.getItem("rememberedUsername");
            localStorage.clear();
            state = {...initialState, isLogged: false};
            if (savedUSername) {
                localStorage.setItem("rememberedUsername", savedUSername);
            }
            window.location.reload()
            
        },
        setAuthData: (state, {payload}: PayloadAction<AuthData>) => {
            // state = {
            //     ...initialState,
            //     sessionData: payload,
            //     isLogged: true,
            // };
            
            state.companyselected = null;
            state.sessionData = payload;
            state.isLogged = true;
            localStorage.setItem('sessionData', JSON.stringify(payload));
            if (payload.Companies?.length === 1) {
                handlerSetCompanySelected(state, {payload: payload.Companies[0], type: "company"})
            }
            state.isLoading = false;
        },
        setCompanySelected: handlerSetCompanySelected,
        loadAuthData: (state) => {
            state.isLoading = true;
            const sessionData = localStorage.getItem('sessionData');
            const companyData = localStorage.getItem('companySelected');
            const userMenuLS = localStorage.getItem('userMenu');
            if (!sessionData) {
                state.isLogged = false;
                state.isLoading = false;
                return
            }
            if (sessionData) {
                state.sessionData = JSON.parse(sessionData);
                state.isLogged = true;
            }
            if (companyData && userMenuLS) {
                state.companyselected = JSON.parse(companyData);
                // let  userMenu = JSON.parse(userMenuLS);
                // state.userMenu = userMenu;
            }
            state.isLoading = false;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload
        },
        setAuthError: (state, action: PayloadAction<string>) => {
            state.autherror = action.payload
        },
        setIdConnection: (state, action: PayloadAction<string>) => {
            state.connectionId = action.payload;
            localStorage.setItem("connectionId", action.payload);
        },
        refreshConnection: (state) => {
            
        },
        setUserData: (state, action: PayloadAction<UserData>) => {
            state.userData = action.payload;
        },
        setSeeInformationAs: (state, {payload}: PayloadAction<SeeInformationAs>) => {
            state.seeInformationAs = payload;
        },
        // refreshToken: (state, action: PayloadAction<string>) => {
        //     // state.userToken = action.payload;
        //     localStorage.setItem('userToken', action.payload);
        // },
        setUserWithoutImage: (state, {payload}: PayloadAction<string>) => {
            const data = state.usersWithoutProfilePicture;
            if (data.includes(`${payload}`)) {
                return;
            }
            state.usersWithoutProfilePicture = [...data, `${payload}`];
        },
        setUserHasProfilePicture: (state, {payload}: PayloadAction<boolean>) => {
            state.userHasProfilePicture = payload;
        },
    }
})


export const { 
    logout,
    setAuthData,
    setCompanySelected,
    loadAuthData,
    setLoading,
    setAuthError,
    setIdConnection,
    setUserData,
    setSeeInformationAs,
    setUserWithoutImage,
    setUserHasProfilePicture,
} = authSlice.actions
